import api from "./index";

export const getEventService = async () =>
  await api.get("/exhibitor/events/by-user");

export const getAllEventsService = async ({ token }) => {
  return await api.patch(
    `/admin/setup-event`,
    { eventSetupName: null, eventsId: null },
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getAllEventsWithVersionService = async ({ token }) => {
  return await api.get("/admin/events", {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAllEventsData = async ({ token, data = {} }) => {
  return await api.patch("/admin/events", data, {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getEventUploadFlows = async ({ token, eventId }) => {
  if (!eventId) return;

  return await api.get(`/event-upload-flow/${eventId}`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const inactivateLinkEventFlow = async ({
  token,
  eventId,
  uploadFlowId,
}) => {
  if (!eventId || !uploadFlowId) return;

  return await api.put(
    `/event-upload-flow/${eventId}/deactivate/${uploadFlowId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const activateLinkEventFlow = async ({
  token,
  eventId,
  uploadFlowId,
}) => {
  if (!eventId || !uploadFlowId) return;

  return await api.put(
    `/event-upload-flow/${eventId}/activate/${uploadFlowId}`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};


export const getActiveSortedEvents = async ({ token }) => {
  try {
    const response = await api.get("/admin/events", {
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    });

    // Filtra apenas os eventos ativos, mapeia e ordena pelo nome
    const mapped = response.data.output
      .filter((ev) => ev.active === true)
      .map((ev) => ({
        value: ev.eventEditionCode,
        label: ev.eventEditionName,
        idNumber: ev.idNumber,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    return mapped;
  } catch (error) {
    console.error("Erro ao buscar eventos ativos:", error);
    throw error;
  }
};